import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDreamteam = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_115_2945)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_115_2945",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 32,
			height: 32,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M32 0H0V32H32V0Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_115_2945)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z",
				fill: "#001E50",
				stroke: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M21.3335 23.1954C21.5936 24.1114 20.5474 24.8382 19.7798 24.2747L16.5861 21.9302C16.2366 21.6737 15.7618 21.6715 15.41 21.9248L12.081 24.3217C11.3119 24.8754 10.2758 24.1486 10.5347 23.237L11.7018 19.1274C11.8101 18.7461 11.683 18.3368 11.3777 18.084L8.03054 15.3118C7.32177 14.7247 7.7153 13.5728 8.63509 13.5422L12.8083 13.4031C13.2244 13.3892 13.5885 13.1189 13.7221 12.7245L15.0452 8.8185C15.3528 7.91063 16.6379 7.91376 16.941 8.82312L18.28 12.84C18.4122 13.2367 18.7774 13.5092 19.1954 13.5232L23.2745 13.6592C24.2052 13.6902 24.592 14.8646 23.8619 15.4426L20.5238 18.0854C20.2067 18.3364 20.072 18.7536 20.1825 19.1426L21.3335 23.1954Z",
				fill: "white"
			})]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_115_2945",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgDreamteam;
